const rootArea = "/contacts";

export const contactsGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (contactCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${contactCode}/read`,
		create: `${baseArea}${rootArea}/${contactCode}/create`,
		update: `${baseArea}${rootArea}/${contactCode}/update`,
		deactivate: `${baseArea}${rootArea}/${contactCode}/deactivate`,
		reactivate: `${baseArea}${rootArea}/${contactCode}/reactivate`
	})
});